import styled from 'styled-components';
import theme from 'styles/theme';

export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const IconWrapper = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #dbeafe 0%, #f3e8ff 100%);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const TitleSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  background-color: ${({ $status }) => {
    if ($status?.toLowerCase() === 'enabled') return '#e7f3ff';
    if ($status?.toLowerCase() === 'disabled') return '#f5f5f5';
    return '#e7f3ff';
  }};
  color: ${({ $status }) => {
    if ($status?.toLowerCase() === 'enabled') return '#007bff';
    if ($status?.toLowerCase() === 'disabled') return '#6c757d';
    return '#007bff';
  }};
`;

export const ActionsSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const ActionButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  img {
    width: 20px;
    height: 20px;
    filter: ${({ $delete }) =>
      $delete ? 'invert(48%) sepia(79%) saturate(2476%) hue-rotate(346deg)' : 'none'};
  }
`;

export const Description = styled.p`
  font-size: 14px;
  color: #6c757d;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;
